module.exports = __webpack_public_path__ + "media/images/flags/64/Macedonia-7a914b27a868882c68282379656453c9.png";